import DepartmentMeasurements from "../groups/DepartmentMeasurements";
import { Group } from "../groups/group"

export interface PromotionProduct {
    id: number;
    productCode: string;
    productDescription: string;
    productShortDescription: string;
    promotionId: number;
    discountType: number;
    discountTypeDescription: string;
    discount: number;
    discountPerc: number;
    pm: string;
    epm: number;
    spm: number;
    euroEstimate: number;
    estimateMeasurement: string;
    estimateQuantity: number;
    actualMeasurement: string;
    actualQuantity: number;
    calculatedMeasurement: string;
    calculatedQuantity: number;
    secondaryCalculatedMeasurement: string | undefined;
    secondaryCalculatedQuantity: number | undefined;
    sellOutEuro: number;
    sellOutEuroIn: number;
}

export function CreateNewPromotionProduct(departmentMeasurements: DepartmentMeasurements, promotionId: number): PromotionProduct {
    return {
        id: 0,
        productCode: '',
        productDescription: '',
        productShortDescription: '',
        promotionId: promotionId,
        discountType: 0,
        discountTypeDescription: '',
        discount: 0,
        discountPerc: 0,
        euroEstimate: 0,
        pm: departmentMeasurements.primaryMeasurementUnit!,
        epm: 0,
        spm: 0,
        estimateMeasurement: departmentMeasurements.predictionMeasurementUnit!,
        estimateQuantity: 0,
        actualMeasurement: departmentMeasurements.actualInputMeasurementUnit!,
        actualQuantity: 0,
        calculatedMeasurement: departmentMeasurements.calculatedMeasurementUnit!,
        calculatedQuantity: 0,
        secondaryCalculatedMeasurement: departmentMeasurements.secondaryCalculatedMeasurementUnit!,
        secondaryCalculatedQuantity: 0,
        sellOutEuro: 0,
        sellOutEuroIn: 0
    }
} 